import { gql } from '@apollo/client';

export const CREATE_PARTNER_FORM = gql`
  mutation CreatePartnerForm($input: createPartnerFormInput) {
    createPartnerForm(input: $input) {
      partnerForm {
        id
        created_at
      }
    }
  }
`;

export const CREATE_QUESTION_FORM = gql`
  mutation CreateQuestionForm($input: createQuestionsFormInput) {
    createQuestionsForm(input: $input) {
      questionsForm {
        id
        created_at
      }
    }
  }
`;
